import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

import BackgroundStyle from "./BackgroundStyle";
import WebShareIcon from "./icons/WebShareIcon";

const MarkdownRender = ({ title, caption, url, markdownData }) => {
  return (
    <>
      <div className="flex justify-end items-end max-w-prose mx-auto pt-5 px-6 sm:px-6 md:px-0 lg:px-0 xl:px-0 2xl:px-0 space-x-2">
        <WebShareIcon title={title} caption={caption} url={url} />
      </div>

      <div className="relative py-10 overflow-hidden sm:mb-10">
        <BackgroundStyle />
        <div className="relative px-6 sm:px-6 md:px-0 lg:px-0 xl:px-0 2xl:px-0 max-w-prose mx-auto">
          <div className="text-sm sm:text-lg">
            {" "}
            <ReactMarkdown className="markdown" remarkPlugins={[remarkGfm]}>
              {markdownData}
            </ReactMarkdown>
          </div>
        </div>
      </div>
    </>
  );
};

export default MarkdownRender;

export const MarkdownRenderWithNoShare = ({ markdownData }) => {
  return (
    <>
      <div className="flex justify-end items-end max-w-prose mx-auto pt-5 px-6 sm:px-6 md:px-0 lg:px-0 xl:px-0 2xl:px-0 space-x-2"></div>

      <div className="relative py-10 overflow-hidden sm:mb-10">
        <BackgroundStyle />
        <div className="relative px-6 sm:px-6 md:px-0 lg:px-0 xl:px-0 2xl:px-0 max-w-prose mx-auto">
          <div className="text-sm sm:text-lg">
            {" "}
            <ReactMarkdown className="markdown" remarkPlugins={[remarkGfm]}>
              {markdownData}
            </ReactMarkdown>
          </div>
        </div>
      </div>
    </>
  );
};
